<template>
    <div v-if="isLoaded">
        <div class="content-body" v-bind:class="{ fullscreen_expand: isFullscreen }">
            <div class="row match-height">
                <div class="col-xl-12 col-lg-12">
                    <div class="card" style="">
                        <div class="card-header">
                            <v-tour name="blogisticTour" :steps="steps" :callbacks="callbacksTour"></v-tour>
                            <h4 class="card-title">Simulador</h4>
                            <a class="heading-elements-toggle"><i class="fa fa-ellipsis-v font-medium-3" @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"></i></a>
                            <div class="heading-elements"  v-bind:class="{ visible: getSubMenuShowHideFw(), '': !getSubMenuShowHideFw() }">
                                <ul class="list-inline mb-0">
                                    <li><a @click="onCreate()" v-b-tooltip title="Cadastrar"><i class="ft-plus" v-if="getPermission('simulador.store')"></i></a></li>
                                    <li><a @click="onActivateDesactivate(1, null, false)" v-b-tooltip title="Ativar Registros" v-if="getPermission('simulador.status')"><i class="fa fa-thumbs-o-up"></i></a></li>
                                    <li><a @click="onActivateDesactivate(2, null, false)" v-b-tooltip title="Inativar Registros" v-if="getPermission('simulador.status')"><i class="fa fa-thumbs-o-down"></i></a></li>
                                    <li><a @click="expandFullscreen()" v-b-tooltip title="Expande a tela" v-if="!isFullscreen"><i class="ft-maximize"></i></a></li>
                                    <li><a @click="expandFullscreen()" v-b-tooltip title="Minimiza a tela" v-if="isFullscreen"><i class="ft-minimize"></i></a></li>
                                    <li><a @click="onFilterShowHide()" v-b-tooltip.hover.left="'Filtros'"><i class="fa fa-filter"></i></a></li>
                                </ul>
                            </div>
                        </div>
                        <div class="card-content">
                            <div class="table-responsive">
                                <div v-if="vuetableFilterRow">
                                    <vuetable-filterbar>
                                    </vuetable-filterbar>
                                </div>
                                <div class="loadingDataPosition">
                                    <div class="loadingData" v-if="loadingData">
                                        <div class="loadingDataSpinner">
                                            <spinner v-if="loadingData" text-fg-color="#ffffff" message="Carregando..."></spinner>
                                        </div>
                                    </div>
                                    <vuetable ref="vuetable"
                                            api-url="/api/simulador"
                                            :fields="fields"
                                            :css="css"
                                            :append-params="moreParams"
                                            track-by="simulador_id"
                                            pagination-path=""
                                            detail-row-component="simulador-detalhes"
                                            @vuetable:cell-clicked="onDetail"
                                            @vuetable:load-error="onError"
                                            @vuetable:pagination-data="onPaginationData"
                                            @vuetable:loaded="onLoaded">
                                        <template slot="status" slot-scope="props">
                                            <span class="label label-success" v-if="props.rowData.status.valor==1">{{ props.rowData.status.descr }}</span>
                                            <span class="label label-warning" v-if="props.rowData.status.valor==2">{{ props.rowData.status.descr }}</span>
                                            <span class="label label-danger" v-if="props.rowData.status.valor==3">{{ props.rowData.status.descr }}</span>
                                        </template>

                                        <template slot="actions" slot-scope="props">
                                            <div class="custom-actions">
                                                <a @click="onEdit(props.rowData, props.rowIndex)" v-b-tooltip title="Editar"  v-if="getPermission('simulador.update')&&props.rowData.status.valor==2"><i class="fa fa-edit"></i></a>
                                                <span v-if="getPermission('simulador.status')">
                                                    <a v-if="props.rowData.status.valor==2" @click="onActivateDesactivate(1, props.rowData, true)" v-b-tooltip title="Ativar"><i class="fa fa-thumbs-o-up"></i></a>
                                                    <a v-if="props.rowData.status.valor==2" @click="onActivateDesactivate(3, props.rowData, true)" v-b-tooltip title="Cancelar"><i class="fa fa-thumbs-o-down"></i></a>
                                                    <a v-if="props.rowData.status.valor==1" @click="onActivateDesactivate(3, props.rowData, true)" v-b-tooltip title="Cancelar"><i class="fa fa-thumbs-o-down"></i></a>
                                                </span>
                                                <a @click="onDetail(props.rowData, null, null)" v-b-tooltip title="Ver detalhes"><i class="fa fa-plus"></i></a>
                                            </div>
                                        </template>
                                    </vuetable>
                                </div>
                                <div>
                                    <div class='col-md-12'>
                                        <div class="pull-left pagination-detail">
                                            <vuetable-pagination-info ref="paginationInfo"
                                                                      :css="css.pagination"
                                                                      info-class="pull-left">
                                            </vuetable-pagination-info>
                                        </div>
                                        <div class="pull-right m-a-0">
                                            <vuetable-pagination ref="pagination"
                                                                 :css="css.pagination"
                                                                 @vuetable-pagination:change-page="onChangePage">
                                            </vuetable-pagination>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
             </div>
         <!-- Modal Component -->
         <b-modal id="modal_form"
              ref="modal_form"
              size="lg"
              :title="modal_titulo"
              :ok-title="modal_botao"
              close-title="Fechar"
              v-model="showModal"
              :ok-disabled=form.errors.any()
              @ok="handleOk">
             <form @submit.stop.prevent="handleOk" @keydown="form.errors.clear($event.target.name)">
             <b-container fluid class="p-a-0">
             <div>
                 <b-row>
                     <b-col>
                         <b-row>
                             <b-col>
                                 <b-form-text>Código <span v-b-tooltip title="Código para identificar o simulador" placement="top">[?]</span></b-form-text>
                                 <b-form-input type="text"
                                             placeholder="Código"
                                             v-model="form.cd"
                                             size="sm">
                                 </b-form-input>
                                 <b-form-feedback class="text-danger" v-text="form.errors.get('cd')" v-if="form.errors.has('cd')"></b-form-feedback>
                             </b-col>
                             <b-col class="p-l-0">
                                 <b-form-text>Descrição <span v-b-tooltip title="Descrição para identificar o simulador" placement="top">[?]</span></b-form-text>
                                 <b-form-input type="text"
                                             placeholder="Descrição"
                                             v-model="form.descr"
                                             size="sm">
                                 </b-form-input>
                                 <b-form-feedback class="text-danger" v-text="form.errors.get('descr')" v-if="form.errors.has('descr')"></b-form-feedback>
                             </b-col>
                             <b-col class="p-a-0">
                                   <b-form-text>Data Simulador <span v-b-tooltip title="Data do simulador" placement="top">[?]</span></b-form-text>
                                   <b-form-input type="text"
                                               placeholder="dd/mm/yyyy"
                                               v-mask="'##/##/####'"
                                               v-model="form.dt_simulador"
                                               name="dt_simulador"
                                               size="sm">
                                   </b-form-input>
                                   <b-form-feedback class="text-danger" v-text="form.errors.get('dt_simulador')" v-if="form.errors.has('dt_simulador')"></b-form-feedback>
                             </b-col>
                         </b-row>
                         <b-row>
                             <b-col>
                               <b-form-text>Município Início <span v-b-tooltip title="Municipio de inicio da prestação utilizado para selecionar a alíquota" placement="top">[?]</span></b-form-text>
                               <multiselect v-model="form.municipio_ini"
                               :options="optionsMunicipioIni"
                               track-by="value"
                               label="label"
                               :hide-selected="true"
                               placeholder="Selecione"
                               tag-placeholder="Selecionar"
                               select-label="Selecionar"
                               selected-label="Selecionado"
                               deselect-label="Remover"
                               ></multiselect>
                               <b-form-feedback class="text-danger" v-text="form.errors.get('municipio_ini.value')" v-if="form.errors.has('municipio_ini.value')"></b-form-feedback>
                             </b-col>
                             <b-col class="p-a-0">
                                 <b-form-text>Município Fim <span v-b-tooltip title="Municipio de fim da prestação utilizado para selecionar a alíquota" placement="top">[?]</span></b-form-text>
                                     <multiselect v-model="form.municipio_fim"
                                     :options="optionsMunicipioFim"
                                     track-by="value"
                                     label="label"
                                     :hide-selected="true"
                                     placeholder="Selecione"
                                     tag-placeholder="Selecionar"
                                     select-label="Selecionar"
                                     selected-label="Selecionado"
                                     deselect-label="Remover"
                                     ></multiselect>
                                 <b-form-feedback class="text-danger" v-text="form.errors.get('municipio_fim.value')" v-if="form.errors.has('municipio_fim.value')"></b-form-feedback>
                             </b-col>
                         </b-row>
                         <b-row>
                             <b-col>
                                 <b-form-text>% Advalorem Receita <span v-b-tooltip title="Percentual utilizado para calculo de ADValorem" placement="top">[?]</span></b-form-text>
                                 <b-form-input type="text"
                                           placeholder="% Advalorem Receita"
                                           v-money="aliquota"
                                           v-model="form.percentual_advalorem"
                                           name="percentual_advalorem"
                                           size="sm">
                                 </b-form-input>
                                 <b-form-feedback class="text-danger" v-text="form.errors.get('percentual_advalorem')" v-if="form.errors.has('percentual_advalorem')"></b-form-feedback>
                             </b-col>
                             <b-col class="p-a-0">
                                 <b-form-text>Valor NFE <span v-b-tooltip title="Valor para simulação" placement="top">[?]</span></b-form-text>
                                 <b-form-input type="text"
                                           placeholder="Valor NFe"
                                           v-money="vlr"
                                           v-model="form.vlr_nfe"
                                           size="sm">
                                 </b-form-input>
                                 <b-form-feedback class="text-danger" v-text="form.errors.get('vlr_nfe')" v-if="form.errors.has('vlr_nfe')"></b-form-feedback>
                             </b-col>
                         </b-row>
                         <b-row>
                             <b-col class="p-r-0">
                               <b-form-text>Observação do simulador <span v-b-tooltip title="Observação interna para o simulador" placement="top">[?]</span></b-form-text>
                               <b-form-textarea name="obs"
                                                v-model="form.obs_simulador"
                                                placeholder="Observação Simulador"
                                                :rows="3"
                                                :max-rows="6">
                               </b-form-textarea>
                               <b-form-feedback class="text-danger" v-text="form.errors.get('obs_simulador')" v-if="form.errors.has('obs_simulador')"></b-form-feedback>
                             </b-col>
                         </b-row>
                     </b-col>
                     <b-col>
                         <h3 class="panel-title">Despesa</h3>
                         <b-row>
                             <b-col class="p-r-0">
                                 <b-form-text>Valor Liquido</b-form-text>
                                 <b-form-input type="text"
                                           placeholder="Liquido"
                                           v-model.lazy="vlr_liquido_despesa_total"
                                           size="sm"
                                           readonly>
                                 </b-form-input>
                                 <b-form-feedback class="text-danger" v-text="form.errors.get('despesa')" v-if="form.errors.has('despesa')"></b-form-feedback>
                             </b-col>
                             <b-col class="p-a-0">
                                 <b-form-text>Valor Impostos</b-form-text>
                                 <b-form-input type="text"
                                           placeholder="Total Impostos"
                                           v-model.lazy="vlr_impostos_despesa_total"
                                           size="sm"
                                           readonly>
                                 </b-form-input>
                                 <b-form-feedback class="text-danger" v-text="form.errors.get('despesa')" v-if="form.errors.has('despesa')"></b-form-feedback>
                             </b-col>
                             <b-col class="p-l-0">
                                 <b-form-text>Valor Bruto</b-form-text>
                                 <b-form-input type="text"
                                            placeholder="Total Bruto"
                                            v-model.lazy="vlr_bruto_despesa_total"
                                            size="sm"
                                            readonly>
                                 </b-form-input>
                                 <b-form-feedback class="text-danger" v-text="form.errors.get('receita')" v-if="form.errors.has('receita')"></b-form-feedback>
                             </b-col>
                         </b-row>
                         <b-row>
                             <b-col class="p-r-0">
                                 <b-form-text>Valor ISS </b-form-text>
                                 <b-form-input type="text"
                                           placeholder="ISS"
                                           v-model.lazy="vlr_iss_despesa_total"
                                           size="sm"
                                           readonly>
                                 </b-form-input>
                                 <b-form-feedback class="text-danger" v-text="form.errors.get('despesa')" v-if="form.errors.has('despesa')"></b-form-feedback>
                             </b-col>
                             <b-col class="p-a-0">
                                 <b-form-text>Valor Pis/Cofins</b-form-text>
                                 <b-form-input type="text"
                                           placeholder="Pis/Cofins"
                                           v-model.lazy="vlr_pis_cofins_despesa_total"
                                           size="sm"
                                           readonly>
                                 </b-form-input>
                                 <b-form-feedback class="text-danger" v-text="form.errors.get('despesa')" v-if="form.errors.has('despesa')"></b-form-feedback>
                             </b-col>
                             <b-col class="p-l-0">
                                 <b-form-text>Valor ICMS </b-form-text>
                                 <b-form-input type="text"
                                           placeholder="ICMS"
                                           v-model.lazy="vlr_icms_despesa_total"
                                           size="sm"
                                           readonly>
                                 </b-form-input>
                                 <b-form-feedback class="text-danger" v-text="form.errors.get('despesa')" v-if="form.errors.has('despesa')"></b-form-feedback>
                             </b-col>
                         </b-row>
                         <b-row>
                             <b-col class="p-r-0">
                                 <b-form-text>Valor Serviços</b-form-text>
                                 <b-form-input type="text"
                                            placeholder="Total Serviços"
                                            v-model.lazy="vlr_servico_despesa_total"
                                            size="sm"
                                            readonly>
                                 </b-form-input>
                                 <b-form-feedback class="text-danger" v-text="form.errors.get('receita')" v-if="form.errors.has('receita')"></b-form-feedback>
                             </b-col>
                             <b-col class="p-l-0">
                                 <b-form-text>Valor Transporte</b-form-text>
                                 <b-form-input type="text"
                                            placeholder="Total Transporte"
                                            v-model.lazy="vlr_transporte_despesa_total"
                                            size="sm"
                                            readonly>
                                 </b-form-input>
                                 <b-form-feedback class="text-danger" v-text="form.errors.get('receita')" v-if="form.errors.has('receita')"></b-form-feedback>
                             </b-col>
                         </b-row>
                     </b-col>
                 </b-row>
             </div>
             </b-container><br>
             <b-container fluid class="p-a-0">
                <b-row>
                    <b-col>
                       <b-tabs>
                          <b-tab title="Trecho" active>
                             <table class="table">
                                <tbody v-for="(row, index) in trecho">
                                   <tr :class="classSubtrecho(row.subtrecho)">
                                      <th style="width: 10%">Principal / Ordem / Advalorem</th>
                                      <th style="width: 10%">Operação</th>
                                      <th style="width: 10%">Modal</th>
                                      <th style="width: 20%">Municípios</th>
                                      <th style="width: 15%">Fornecedor</th>
                                      <th style="width: 5%">Ações</th>
                                   </tr>
                                   <tr :class="classSubtrecho(row.subtrecho)" style="display: table-row;">
                                       <td class="p-a-0 m-a-0">
                                          <b-row class="p-a-0 m-a-0">
                                             <b-col cols="2" class="p-a-0">
                                                <b-form-checkbox buttons
                                                                 button-variant="primary"
                                                                 v-model="row.principal"
                                                                 value="1"
                                                                 unchecked-value="2">
                                                </b-form-checkbox>
                                                <b-form-feedback class="text-danger" v-text="form.errors.get('trecho.'+index+'.principal.value')" v-if="form.errors.has('trecho.'+index+'.principal.value')"></b-form-feedback>
                                             </b-col>
                                             <b-col cols="10" class="p-a-0">
                                                <b-form-input type="text"
                                                               placeholder="Ordem"
                                                               v-model="row.ordem"
                                                               size="sm">
                                                </b-form-input>
                                                <b-form-feedback class="text-danger" v-text="form.errors.get('trecho.'+index+'.ordem')" v-if="form.errors.has('trecho.'+index+'.ordem')"></b-form-feedback>
                                             </b-col>
                                         </b-row>
                                         <b-row class="p-a-0 m-a-0">
                                             <b-col class="p-a-0">
                                                <b-form-input type="text"
                                                             placeholder="% Advalorem"
                                                             v-model="row.advalorem"
                                                             size="sm">
                                                </b-form-input>
                                                <b-form-feedback class="text-danger" v-text="form.errors.get('trecho.'+index+'.advalorem')" v-if="form.errors.has('trecho.'+index+'.advalorem')"></b-form-feedback>
                                             </b-col>
                                          </b-row>
                                      </td>
                                      <td class="p-a-0">
                                            <b-col class="p-a-0">
                                                <multiselect v-model="row.tp_trecho_custo"
                                                :options="optionsLivTpTrechoCusto"
                                                track-by="value"
                                                label="label"
                                                :hide-selected="true"
                                                placeholder="Selecione"
                                                tag-placeholder=""
                                                select-label=""
                                                selected-label="Selecionado"
                                                deselect-label="Remover"
                                                ></multiselect>
                                                <b-form-feedback class="text-danger" v-text="form.errors.get('trecho.'+index+'.tp_trecho_custo.value')" v-if="form.errors.has('trecho.'+index+'.tp_trecho_custo.value')"></b-form-feedback>
                                            </b-col>
                                      </td>
                                      <td class="p-a-0">
                                         <b-row>
                                            <b-col class="p-a-0" v-if="row.tp_trecho_custo.value==1">
                                                <multiselect v-model="row.modal"
                                                :options="optionsBModal"
                                                track-by="value"
                                                label="label"
                                                :hide-selected="true"
                                                placeholder="Selecione"
                                                tag-placeholder=""
                                                select-label=""
                                                selected-label="Selecionado"
                                                deselect-label="Remover"
                                                ></multiselect>
                                                <b-form-feedback class="text-danger" v-text="form.errors.get('trecho.'+index+'.modal.value')" v-if="form.errors.has('trecho.'+index+'.modal.value')"></b-form-feedback>
                                            </b-col>
                                         </b-row>
                                      </td>
                                     <td class="p-a-0">
                                        <b-row>
                                            <b-col class="p-a-0">
                                              <multiselect v-model="row.municipio_ini"
                                              :options="optionsMunicipioIni"
                                              track-by="value"
                                              label="label"
                                              :hide-selected="true"
                                              placeholder="Inicio"
                                              tag-placeholder=""
                                              select-label=""
                                              selected-label="Selecionado"
                                              deselect-label="Remover"
                                              ></multiselect>
                                              <b-form-feedback class="text-danger" v-text="form.errors.get('trecho.'+index+'.municipio_ini.value')" v-if="form.errors.has('trecho.'+index+'.municipio_ini.value')"></b-form-feedback>
                                          </b-col>
                                          <b-col class="p-a-0">
                                          <span v-if="row.tp_trecho_custo.value==1">
                                              <multiselect v-model="row.municipio_fim"
                                              :options="optionsMunicipioFim"
                                              track-by="value"
                                              label="label"
                                              :hide-selected="true"
                                              placeholder="Fim"
                                              tag-placeholder=""
                                              select-label=""
                                              selected-label="Selecionado"
                                              deselect-label="Remover"
                                              ></multiselect>
                                              <b-form-feedback class="text-danger" v-text="form.errors.get('trecho.'+index+'.municipio_fim.value')" v-if="form.errors.has('trecho.'+index+'.municipio_fim.value')"></b-form-feedback>
                                          </span>
                                          </b-col>
                                        </b-row>
                                     </td>
                                     <td class="p-a-0">
                                      <b-col class="p-a-0">
                                        <multiselect v-model="row.fornecedor"
                                        :options-limit="300"
                                        :limit="2"
                                        :limit-text="limitText"
                                        :options="optionsFornecedor"
                                        track-by="value"
                                        label="label"
                                        :hide-selected="true"
                                        placeholder="Fornecedor ( Digite para pesquisar )"
                                        tag-placeholder="Selecionar"
                                        select-label="Selecionar"
                                        selected-label="Selecionado"
                                        deselect-label="Remover"
                                        :searchable="true"
                                        :loading="isLoadingFor"
                                        @search-change="listaClientesFornecedor"
                                        ></multiselect>
                                        <b-form-feedback class="text-danger" v-text="form.errors.get('trecho.'+index+'.fornecedor.value')" v-if="form.errors.has('trecho.'+index+'.fornecedor.value')"></b-form-feedback>
                                      </b-col>
                                    </td>
                                    <td align='text-right'>
                                      <i class="fa fa-times" style="cursor: pointer" v-b-tooltip.hover.right="'Remover Linha'" v-on:click="removeRowTrecho(index);"></i>
                                      <span v-if="row.modal.cd!=6&&form.municipio_ini!=''&&form.municipio_fim!=''">
                                          <i class="fa fa-plus-square" v-on:click="addRowTrechoCusto($event,row,index);" v-b-tooltip.hover.right="'Adicionar Custo'" style="cursor: pointer;"></i>
                                      </span>
                                      <span v-if="form.municipio_ini==''||form.municipio_fim==''">
                                          <i class="fa fa-info" v-b-tooltip.hover.right="'Favor definir os municipios nas parametrizações para adicionar custos'" style="cursor: pointer;"></i>
                                      </span>
                                      <span v-if="row.modal.cd==6">
                                          <i class="fa fa-plus-square-o" v-on:click="addRowSubTrecho($event,row);" v-b-tooltip.hover.right="'Adicionar Subtrecho'" style="cursor: pointer"></i>
                                      </span>
                                    </td>
                                 </tr>
                                 <tr v-if="row.modal.cd!=6">
                                   <td colspan="8">
                                     <table class="table">
                                         <tr>
                                             <th style="width: 10%" class="p-a-0">Custo</th>
                                             <th style="width: 15%" class="p-a-0">Vlr Liquido</th>
                                             <th style="width: 15%" class="p-a-0"><span v-if="row.tp_trecho_custo.value==1">Alíquota ICMS</span><span v-if="row.tp_trecho_custo.value==2">Alíquota ISS</span></th>
                                             <th style="width: 15%" class="p-a-0"><span v-if="row.tp_trecho_custo.value==1">ICMS</span><span v-if="row.tp_trecho_custo.value==2">ISS</span></th>
                                             <th style="width: 15%" class="p-a-0">PIS/COFINS</th>
                                             <th style="width: 15%" class="p-a-0">Vlr Total</th>
                                             <th style="width: 5%" class="p-a-0">Ações</th>
                                         </tr>
                                          <tbody>
                                             <tr v-for="(row2, index2) in row.trecho_custo" style="display: table-row;">
                                               <td class="p-a-0">
                                                 <b-col class="p-a-0">
                                                     <multiselect v-model="row2.custo"
                                                     :options="optionsCusto"
                                                     track-by="value"
                                                     label="label"
                                                     :hide-selected="true"
                                                     placeholder="Selecione"
                                                     tag-placeholder=""
                                                     select-label=""
                                                     selected-label="Selecionado"
                                                     deselect-label="Remover"
                                                     ></multiselect>
                                                     <b-form-feedback class="text-danger" v-text="form.errors.get('trecho.'+index+'.trecho_custo.'+index2+'.custo.value')" v-if="form.errors.has('trecho.'+index+'.trecho_custo.'+index2+'.custo.value')"></b-form-feedback>
                                                 </b-col>
                                               </td>
                                               <td class="p-a-0">
                                                 <b-col class="p-a-0">
                                                     <b-form-input type="text"
                                                                 @change="getDespesaCustoLinha(row2, row, form)"
                                                                 placeholder="Valor"
                                                                 v-model="row2.valor"
                                                                 size="sm">
                                                     </b-form-input>
                                                     <b-form-feedback class="text-danger" v-text="form.errors.get('trecho.'+index+'.trecho_custo.'+index2+'.valor')" v-if="form.errors.has('trecho.'+index+'.trecho_custo.'+index2+'.valor')"></b-form-feedback>
                                                 </b-col>
                                               </td>
                                               <td class="p-a-0" v-if="row.tp_trecho_custo.value==1">
                                                 <b-col class="p-a-0">
                                                     <b-form-input type="text"
                                                                 placeholder="Aliquota"
                                                                 v-model="row2.aliquota_icms"
                                                                 size="sm"
                                                                 readonly>
                                                     </b-form-input>
                                                     <b-form-feedback class="text-danger" v-text="form.errors.get('trecho.'+index+'.trecho_custo.'+index2+'.aliquota_icms')" v-if="form.errors.has('trecho.'+index+'.trecho_custo.'+index2+'.aliquota_icms')"></b-form-feedback>
                                                 </b-col>
                                               </td>
                                               <td class="p-a-0" v-if="row.tp_trecho_custo.value==2">
                                                 <b-col class="p-a-0">
                                                     <b-form-input type="text"
                                                                 placeholder="Aliquota"
                                                                 v-model="row2.aliquota_iss"
                                                                 size="sm"
                                                                 readonly>
                                                     </b-form-input>
                                                     <b-form-feedback class="text-danger" v-text="form.errors.get('trecho.'+index+'.trecho_custo.'+index2+'.aliquota_iss')" v-if="form.errors.has('trecho.'+index+'.trecho_custo.'+index2+'.aliquota_iss')"></b-form-feedback>
                                                 </b-col>
                                               </td>
                                               <td class="p-a-0" v-if="row.tp_trecho_custo.value==1">
                                                 <b-col class="p-a-0">
                                                     <b-form-input type="text"
                                                                 placeholder="Valor"
                                                                 v-model="row2.vlr_icms"
                                                                 size="sm"
                                                                 readonly>
                                                     </b-form-input>
                                                     <b-form-feedback class="text-danger" v-text="form.errors.get('trecho.'+index+'.trecho_custo.'+index2+'.vlr_icms')" v-if="form.errors.has('trecho.'+index+'.trecho_custo.'+index2+'.vlr_icms')"></b-form-feedback>
                                                 </b-col>
                                               </td>
                                               <td class="p-a-0" v-if="row.tp_trecho_custo.value==2">
                                                 <b-col class="p-a-0">
                                                     <b-form-input type="text"
                                                                 placeholder="Valor"
                                                                 v-model="row2.vlr_iss"
                                                                 size="sm"
                                                                 readonly>
                                                     </b-form-input>
                                                     <b-form-feedback class="text-danger" v-text="form.errors.get('trecho.'+index+'.trecho_custo.'+index2+'.vlr_iss')" v-if="form.errors.has('trecho.'+index+'.trecho_custo.'+index2+'.vlr_iss')"></b-form-feedback>
                                                 </b-col>
                                               </td>
                                               <td class="p-a-0">
                                                 <b-col class="p-a-0">
                                                     <b-form-input type="text"
                                                                 placeholder="Valor"
                                                                 v-model="row2.vlr_pis_cofins"
                                                                 size="sm"
                                                                 readonly>
                                                     </b-form-input>
                                                     <b-form-feedback class="text-danger" v-text="form.errors.get('trecho.'+index+'.trecho_custo.'+index2+'.vlr_pis_cofins')" v-if="form.errors.has('trecho.'+index+'.trecho_custo.'+index2+'.vlr_pis_cofins')"></b-form-feedback>
                                                 </b-col>
                                               </td>
                                               <td class="p-a-0">
                                                 <b-col class="p-a-0">
                                                     <b-form-input type="text"
                                                                 placeholder="Custo Bruto"
                                                                 v-model="row2.vlr_bruto"
                                                                 size="sm"
                                                                 readonly>
                                                     </b-form-input>
                                                     <b-form-feedback class="text-danger" v-text="form.errors.get('trecho.'+index+'.trecho_custo.'+index2+'.vlr_bruto')" v-if="form.errors.has('trecho.'+index+'.trecho_custo.'+index2+'.vlr_bruto')"></b-form-feedback>
                                                 </b-col>
                                               </td>
                                               <td>
                                                 <i class="glyphicon glyphicon-remove" style="cursor: pointer" v-b-tooltip.hover.right="'Remover Linha'" v-on:click="removeRowTrechoCusto(row,index2);"></i>
                                               </td>
                                            </tr>
                                         </tbody>
                                      </table>
                                   </td>
                                 </tr>

                                 <tr v-if="row.subtrechos.length>=1">
                                     <td>
                                         <b-row>
                                             <b-col>
                                                 <b-form-text>Valor total</b-form-text>
                                                 <b-form-input type="text"
                                                             placeholder="Valor"
                                                             @change="getDespesaCusto"
                                                             v-model="row.vlr_total_subtrecho"
                                                             size="sm">
                                                 </b-form-input>
                                                 <b-form-feedback class="text-danger" v-text="form.errors.get('trecho.trecho_custo.'+index+'.vlr_total_subtrecho')" v-if="form.errors.has('trecho.trecho_custo.'+index+'.valor')"></b-form-feedback>
                                             </b-col>
                                         </b-row>
                                     </td>
                                     <td colspan="8">
                                         <table class="table">
                                             <tbody v-for="(row2, index2) in row.subtrechos">
                                                 <tr :class="classSubtrecho(row2.subtrecho)">
                                                     <th style="width: 10%">Ordem</th>
                                                     <th style="width: 10%">Operação</th>
                                                     <th style="width: 10%">Modal</th>
                                                     <th style="width: 20%">Municípios</th>
                                                     <th style="width: 10%">Descrição</th>
                                                     <th style="width: 10%">Custo</th>
                                                     <th style="width: 5%">Ações</th>
                                                 </tr>
                                                 <tr :class="classSubtrecho(row2.subtrecho)" style="display: table-row;">
                                                     <td class="p-a-0 m-a-0">
                                                         <b-col class="p-a-0">
                                                             <b-form-input type="text"
                                                                         placeholder="Ordem"
                                                                         v-model="row2.ordem"
                                                                         size="sm">
                                                             </b-form-input>
                                                             <b-form-feedback class="text-danger" v-text="form.errors.get('trecho.'+index+'.subtrechos.'+index2+'.ordem')" v-if="form.errors.has('trecho.'+index+'.subtrechos.'+index2+'.ordem')"></b-form-feedback>
                                                         </b-col>
                                                   </td>
                                                   <td class="p-a-0">
                                                         <b-col class="p-a-0">
                                                             <multiselect v-model="row2.tp_trecho_custo"
                                                             :options="optionsLivTpTrechoCusto"
                                                             track-by="value"
                                                             label="label"
                                                             :hide-selected="true"
                                                             placeholder="Selecione"
                                                             tag-placeholder=""
                                                             select-label=""
                                                             selected-label="Selecionado"
                                                             deselect-label="Remover"
                                                             ></multiselect>
                                                             <b-form-feedback class="text-danger" v-text="form.errors.get('trecho.'+index+'.subtrechos.'+index2+'.tp_trecho_custo.value')" v-if="form.errors.has('trecho.'+index+'.subtrechos.'+index2+'.tp_trecho_custo.value')"></b-form-feedback>
                                                         </b-col>
                                                   </td>
                                                   <td class="p-a-0">
                                                       <b-col class="p-a-0" v-if="row2.tp_trecho_custo.value==1">
                                                         <multiselect v-model="row2.modal"
                                                         :options="optionsBModal"
                                                         track-by="value"
                                                         label="label"
                                                         :hide-selected="true"
                                                         placeholder="Selecione"
                                                         tag-placeholder=""
                                                         select-label=""
                                                         selected-label="Selecionado"
                                                         deselect-label="Remover"
                                                         ></multiselect>
                                                         <b-form-feedback class="text-danger" v-text="form.errors.get('trecho.'+index+'.subtrechos.'+index2+'.modal.value')" v-if="form.errors.has('trecho.'+index+'.subtrechos.'+index2+'.modal.value')"></b-form-feedback>
                                                       </b-col>
                                                   </td>
                                                   <td>
                                                       <b-row>
                                                           <b-col class="p-a-0">
                                                             <multiselect v-model="row2.municipio_ini"
                                                             :options="optionsMunicipioIni"
                                                             track-by="value"
                                                             label="label"
                                                             :hide-selected="true"
                                                             placeholder="Inicio"
                                                             tag-placeholder=""
                                                             select-label=""
                                                             selected-label="Selecionado"
                                                             deselect-label="Remover"
                                                             ></multiselect>
                                                             <b-form-feedback class="text-danger" v-text="form.errors.get('trecho.'+index+'.subtrechos.'+index2+'.municipio_ini.value')" v-if="form.errors.has('trecho.'+index+'.subtrechos.'+index2+'.municipio_ini.value')"></b-form-feedback>
                                                         </b-col>
                                                         <b-col class="p-a-0" v-if="row2.tp_trecho_custo.value==1">
                                                             <span>
                                                                 <multiselect v-model="row2.municipio_fim"
                                                                 :options="optionsMunicipioFim"
                                                                 track-by="value"
                                                                 label="label"
                                                                 :hide-selected="true"
                                                                 placeholder="Fim"
                                                                 tag-placeholder=""
                                                                 select-label=""
                                                                 selected-label="Selecionado"
                                                                 deselect-label="Remover"
                                                                 ></multiselect>
                                                                 <b-form-feedback class="text-danger" v-text="form.errors.get('trecho.'+index+'.subtrechos.'+index2+'.municipio_fim.value')" v-if="form.errors.has('trecho.'+index+'.subtrechos.'+index2+'.municipio_fim.value')"></b-form-feedback>
                                                             </span>
                                                         </b-col>
                                                     </b-row>
                                                 </td>
                                                 <td>
                                                   <b-col class="p-a-0">
                                                       <b-form-input type="text"
                                                                   placeholder="Descrição"
                                                                   v-model="row2.descr_custo"
                                                                   size="sm">
                                                       </b-form-input>
                                                       <b-form-feedback class="text-danger" v-text="form.errors.get('trecho.'+index+'.subtrechos.'+index2+'.descr')" v-if="form.errors.has('trecho.'+index+'.subtrechos.'+index2+'.descr')"></b-form-feedback>
                                                   </b-col>
                                                 </td>
                                                 <td class="p-a-0">
                                                   <b-col class="p-a-0">
                                                       <multiselect v-model="row2.custo"
                                                       :options="optionsCusto"
                                                       track-by="value"
                                                       label="label"
                                                       :hide-selected="true"
                                                       placeholder="Selecione"
                                                       tag-placeholder=""
                                                       select-label=""
                                                       selected-label="Selecionado"
                                                       deselect-label="Remover"
                                                       ></multiselect>
                                                       <b-form-feedback class="text-danger" v-text="form.errors.get('trecho.'+index+'.subtrechos.'+index2+'.custo.value')" v-if="form.errors.has('trecho.'+index+'.subtrechos.'+index2+'.custo.value')"></b-form-feedback>
                                                   </b-col>
                                                 </td>
                                                 <td align='text-right'>
                                                     <i class="fa fa-times" style="cursor: pointer" v-b-tooltip.hover.right="'Remover Linha'" v-on:click="removeRowSubTrecho(row, index2);"></i>
                                                 </td>
                                              </tr>
                                         </tbody>
                                     </table>
                                   </td>
                                </tr>
                             </tbody>
                         </table>
                         <table class="table">
                             <tbody>
                                 <tr class="table-info" style="display: table-row;">
                                     <td colspan="11" style="width: 90%">
                                     </td>
                                     <td class='text-right' style="width: 90%; ">
                                         <i class="fa fa-plus-square" v-on:click="addRowTrecho($event,2);" v-b-tooltip.hover.right="'Adicionar Trecho'" style="cursor: pointer;"></i>
                                     </td>
                                 </tr>
                             </tbody>
                         </table>
                     </b-tab>
                     <b-tab title="Receita" >
                        <table class="table">
                           <thead>
                              <tr>
                                 <th style="width: 10%">Componente*</th>
                                 <th style="width: 15%">Valor Liquido*</th>
                                 <th style="width: 15%">Alíquota</th>
                                 <th style="width: 15%">ICMS/ISS</th>
                                 <th style="width: 15%">PIS/COFINS</th>
                                 <th style="width: 15%">Vlr Total</th>
                                 <th style="width: 5%">Ações</th>
                              </tr>
                           </thead>
                           <tbody>
                              <tr v-for="(row, index) in receita">
                                  <b-col class="p-a-0">
                                      <multiselect v-model="row.tp_trecho_custo"
                                      :options="optionsLivTpTrechoCusto"
                                      track-by="value"
                                      label="label"
                                      :hide-selected="true"
                                      placeholder="Selecione"
                                      tag-placeholder=""
                                      select-label=""
                                      selected-label="Selecionado"
                                      deselect-label="Remover"
                                      ></multiselect>
                                      <b-form-feedback class="text-danger" v-text="form.errors.get('trecho.'+index+'.tp_trecho_custo.value')" v-if="form.errors.has('trecho.'+index+'.tp_trecho_custo.value')"></b-form-feedback>
                                  </b-col>
                                  <b-col class="p-a-0">
                                       <multiselect v-model="row.custo"
                                       :options="optionsCustoCFrete"
                                       track-by="value"
                                       label="label"
                                       :hide-selected="true"
                                       placeholder="Selecione"
                                       tag-placeholder="Selecionar"
                                       select-label="Selecionar"
                                       selected-label="Selecionado"
                                       deselect-label="Remover"
                                       ></multiselect>
                                       <b-form-feedback class="text-danger" v-text="form.errors.get('receita.'+index+'.custo.value')" v-if="form.errors.has('receita.'+index+'.custo.value')"></b-form-feedback>
                                   </b-col>
                                   <b-col class="p-a-0">
                                         <b-form-input type="text"
                                                     placeholder="Valor"
                                                     v-model="row.valor"
                                                     @change="getReceitaCustoLinha(row, form)"
                                                     size="sm">
                                         </b-form-input>
                                         <b-form-feedback class="text-danger" v-text="form.errors.get('receita.'+index+'.valor')" v-if="form.errors.has('receita.'+index+'.valor')"></b-form-feedback>
                                   </b-col>
                                   <b-col class="p-a-0">
                                         <b-form-input type="text"
                                                     placeholder="Aliquota"
                                                     v-model="row.aliquota_icms"
                                                     size="sm"
                                                     readonly>
                                         </b-form-input>
                                         <b-form-feedback class="text-danger" v-text="form.errors.get('receita.'+index+'.aliquota_icms')" v-if="form.errors.has('receita.'+index+'.aliquota_icms')"></b-form-feedback>
                                     </b-col>
                                     <b-col class="p-a-0">
                                         <b-form-input type="text"
                                                     placeholder="Valor"
                                                     v-model="row.vlr_icms"
                                                     size="sm"
                                                     readonly>
                                         </b-form-input>
                                         <b-form-feedback class="text-danger" v-text="form.errors.get('receita.'+index+'.vlr_icms')" v-if="form.errors.has('receita.'+index+'.vlr_icms')"></b-form-feedback>
                                     </b-col>
                                     <b-col class="p-a-0">
                                         <b-form-input type="text"
                                                     placeholder="Valor"
                                                     v-model="row.vlr_pis_cofins"
                                                     size="sm"
                                                     readonly>
                                         </b-form-input>
                                         <b-form-feedback class="text-danger" v-text="form.errors.get('receita.'+index+'.vlr_pis_cofins')" v-if="form.errors.has('receita.'+index+'.vlr_pis_cofins')"></b-form-feedback>
                                     </b-col>
                                     <b-col class="p-a-0">
                                         <b-form-input type="text"
                                                     placeholder="Custo Bruto"
                                                     v-model="row.vlr_bruto"
                                                     size="sm"
                                                     readonly>
                                         </b-form-input>
                                         <b-form-feedback class="text-danger" v-text="form.errors.get('receita.'+index+'.vlr_bruto')" v-if="form.errors.has('receita.'+index+'.vlr_bruto')"></b-form-feedback>
                                     </b-col>
                                     <b-col class="p-a-0">
                                       <i class="glyphicon glyphicon-remove" style="cursor: pointer" v-b-tooltip.hover.right="'Remover Linha'" v-on:click="removeRowReceita(index);"></i>
                                   </b-col>
                               </tr>
                           </tbody>
                           <td colspan="6"></td>
                           <td>
                             <i class="font-icon font-icon-plus" v-on:click="addRowReceita($event);" v-b-tooltip.hover.right="'Adicionar Linha'" style="cursor: pointer"></i>
                           </td>
                       </table>
                    </b-tab>
                 </b-tabs>
              </b-col>
           </b-row>
        </b-container fluid class="p-a-0">
      </form>
      <div slot="modal-footer" class="w-100">
         <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner>
         </div>
         <div class="float-right">
             <div class="float-left" v-if="this.errors_array.length>0">
                 <b-btn class="label label-warning" @click="showPopover = !showPopover" id="popoverButton-sync" v-b-tooltip.hover.left="'Clique aqui para ver os erros encontrados'" variant="warning"><i class="fa fa-exclamation-triangle fa-2x"></i>
                 </b-btn>
                 <b-popover :show.sync="showPopover" target="popoverButton-sync" title="<strong>Erros Encontrados</strong>" data-html="true" placement="leftbottom">
                     <table class="table" id="mais">
                         <tbody>
                             <tr class="bg-gray-light" style="display: table-row;" v-for="item in this.errors_array">
                                 <td>
                                   {{ item.erro }}
                                 </td>
                             </tr>
                         </tbody>
                     </table>
                 </b-popover>
             </div>
             &nbsp;

             <b-btn @click="showModal=false" variant="secondary">
               Fechar
             </b-btn>
             <b-btn @click="handleOk($event)" variant="secondary" :disabled="isDisabled">
               Enviar
             </b-btn>
         </div>
     </div>
     </b-modal>
    </div>
</div>
</template>
<script>
import { formatCNPJFromParts } from "../utils";

import Vuetable from '../components/Vuetable'
import VuetablePagination from '../components/VuetablePagination'
import VuetablePaginationInfo from '../components/VuetablePaginationInfo'
import PedidoFilterBar from './PedidoFilterBar'
import moment from 'moment'
import accounting from 'accounting'
import {VMoney} from 'v-money'
import SimuladorDetalhes from './SimuladorDetalhes'

Vue.component('simulador-detalhes', SimuladorDetalhes);

export default {
    components: {
        Vuetable,
        VuetablePagination,
        VuetablePaginationInfo,
        'vuetable-filterbar': PedidoFilterBar,
        VMoney,
    },
    data () {
        return {
          dataExport: [],
          modal_titulo: '',
          modal_botao: '',
          modal_acao: '',
          showPopover: false,
          isLoadingFor: false,
          loading: false,
          isDisabled: false,
          loadingData: true,
          showModal: false,
          isFullscreen: false,
          optionsLivStatus: [],
          optionsStatus: [],
          optionsMunicipioIni: [],
          optionsMunicipioFim: [],
          optionsFornecedor: [],
          optionsLivStatusTrecho: [],
          optionsLivTpTrecho: [],
          optionsLivTpCusto: [],
          optionsBModal: [],
          optionsLivTpTrechoCusto: [],
          optionsLivStatusTrechoCusto: [],
          optionsLivTpCustoTrecho: [],
          optionsCusto: [],
          optionsCustoCFrete: [],
          Icms: [],
          Iss: [],
          //
          vn_vlr_aliquota: 0,
          vv_vlr_aliquota_exib: 0,
          vlr_liquido: 0,
          vlr_icms: 0,
          vlr_pis_cofins: 0,
          vlr_bruto: 0,
          vlr_liquido_despesa_total: 0,
          vlr_bruto_despesa_total: 0,
          vlr_icms_despesa_total: 0,
          vlr_pis_cofins_despesa_total: 0,
          vlr_iss_despesa_total: 0,
          vlr_impostos_despesa_total: 0,
          vlr_transporte_despesa_total: 0,
          vlr_servico_despesa_total: 0,
          // receita
          vlr_liquido_receita_total: 0,
          vlr_bruto_receita_total: 0,
          vlr_icms_receita_total: 0,
          vlr_pis_cofins_receita_total: 0,
          vlr_iss_receita_total: 0,
          vlr_impostos_receita_total: 0,
          vlr_transporte_receita_total: 0,
          vlr_servico_receita_total: 0,
          //
          receita: [{ valor: 0,
                         aliquota_icms: 0,
                         aliquota_iss: 0,
                         vlr_icms: 0,
                         vlr_iss: 0,
                         vlr_pis_cofins: 0,
                         vlr_bruto: 0,
                         custo: []
                     }],
          errors_array: [],
          trecho: [ { status: 2,
                     tp_trecho: [],
                     tp_custo: 2,
                     modal: [],
                     municipio_ini: [],
                     municipio_fim: [],
                     principal: 2,
                     ordem: '',
                     simtre_id: '',
                     fornecedor: [],
                     tp_trecho_custo: [],
                     advalorem: '',
                     vlr_total_subtrecho: 0,
                     subtrecho: 2,
                     subtrechos: [
                                    { status: 2,
                                        tp_trecho: [],
                                        tp_custo: 2,
                                        modal: [],
                                        municipio_ini: [],
                                        municipio_fim: [],
                                        principal: 2,
                                        ordem: '',
                                        simtre_id: '',
                                        tp_trecho_custo: [],
                                        subtrecho: 1,
                                        descr_subtrecho: '',
                                        custo_subtrecho: []
                                     }
                                ],
                     trecho_custo: [ { status: 1,
                                    tp_custo_trecho: [],
                                    descr: '',
                                    valor: 0,
                                    aliquota_icms: 0,
                                    aliquota_iss: 0,
                                    vlr_icms: 0,
                                    vlr_iss: 0,
                                    vlr_pis_cofins: 0,
                                    vlr_bruto: 0,
                                    simtre_id: '',
                                    custo: []
                                }],
                  }],
         form: new Form({ descr: '',
                            cd: '',
                           obs_simulador: '',
                           dt_simulador: '',
                           percentual_advalorem: 0,
                           vlr_nfe: '',
                           simulador_id: '',
                           status: [],
                           municipio_ini: [],
                           municipio_fim: [],
                           trecho: [],
                           custo_receita: [],
                           seguro: [],
                       }),
         formuc: new Form({qtde_uc: '',
                          simulador_id: '',
                 }),
         aliquota: {
             decimal: ',',
             prefix: '% ',
             precision: 2,
             masked: false /* doesn't work with directive */
         },
         vlr: {
             decimal: ',',
             thousands: '.',
             prefix: 'R$ ',
             precision: 2,
             masked: false /* doesn't work with directive */
         },
         helpForm: new Form({statusRecord: [], params: [],search:'', status: ''}),
         fields: [
          {
              name: '__checkbox',
              titleClass: 'center aligned',
              dataClass: 'center aligned'
          },
          {
            name: '__slot:pessoa',
            title: 'CPNJ/Razão Social',
            sortField: 'pessoa'
          },
          {
            name: 'num_simulador',
            title: 'N° Pedido',
            sortField: 'num_simulador'
          },
          {
            name: 'descr',
            title: 'Descrição',
            sortField: 'descr'
          },
          {
            name: 'dt_simulador',
            title: 'Data do Pedido',
            callback: 'formatDate|DD/MM/YYYY'
          },
          {
            name: '__slot:status',
            title: 'Status',
            sortField: 'status'
          },
          {
              name: '__slot:actions',   // <----
              title: 'Ações',
              titleClass: 'center aligned',
              dataClass: 'center aligned'
          }
      ],
      css: {
          loadingClass: 'loading',
          ascendingIcon: 'glyphicon glyphicon-chevron-up',
          descendingIcon: 'glyphicon glyphicon-chevron-down',
          handleIcon: 'glyphicon glyphicon-menu-hamburger',
      },
      moreParams: {}
       }
    },
    directives: {
        money: VMoney,
        aliquota: VMoney,
        vlr: VMoney,
        qtd: VMoney,
        percentual_reducao_bc: VMoney
    },
    mounted() {
        this.$events.$on('filter-set', eventData => this.onFilterSet(eventData));
        this.$events.$on('filter-reset', e => this.onFilterReset());
        this.getLivGeral();
      },
    methods: {
        onPaginationData (paginationData) {
          this.$refs.pagination.setPaginationData(paginationData)
          this.$refs.paginationInfo.setPaginationData(paginationData)
        },
        onChangePage (page) {
          this.$refs.vuetable.changePage(page)
        },
        onFilterSet (data_filter) {
            this.loadingData = true;
            this.moreParams = {
                'num_simulador': data_filter.num_simulador,
                'num_uc': data_filter.num_uc,
                'tom_cnpj': data_filter.tom_cnpj,
                'for_cnpj': data_filter.for_cnpj,
                'dt_inicio': data_filter.dt_inicio,
                'dt_fim': data_filter.dt_fim,
                'status': data_filter.status.value
            }
            Vue.nextTick( () => {this.$refs.vuetable.reload(); })
        },
        onFilterReset () {
            this.loadingData = true;
            this.moreParams = {}
            Vue.nextTick( () => this.$refs.vuetable.refresh())
        },
        onFilterShowHide() {
            if(this.vuetableFilterRow)
            {
                this.$store.commit('setVuetableFilterRow', false);
            }
            else
            {
                this.$store.commit('setVuetableFilterRow', true);
            }
        },
        onLoaded: function () {
            this.dataExport = this.$refs.vuetable.tableData;
            this.loadingData = false;
            this.$store.commit('setVuetableFilterButton', false);
        },
        onDetail (data, field, event) {
            this.$refs.vuetable.toggleDetailRow(data.simulador_id);
        },
        classSubtrecho : function(subtrecho){
            if(subtrecho==1)
            {
                return 'table-success';
            }
            else
            {
                return 'table-info';
            }
        },
        handleOk(e)
        {
            e.preventDefault();
            if(this.modal_acao=="i")
            {
               this.onStore();
            }
            else
            {
                this.onUpdate(this.form.simulador_id);
            }
        },
        onCreate ()
        {
          this.isDisabled = false;
          this.loading = false;
          this.modal_titulo = "Cadastrar";
          this.modal_botao = "Cadastrar";
          this.modal_acao = "i";
          this.form.reset();
          this.trecho = '';
          this.trecho = [];
          this.errors_array = '';
          this.errors_array = [];
          this.$refs.modal_form.show();
        },
        onEdit (data, index)
        {
            this.isDisabled = false;
            this.loading = false;
            this.modal_titulo = "Alterar Simulador";
            this.modal_botao = "Alterar Simulador";
            this.modal_acao = "u";
            this.form.reset();
            this.errors_array = '';
            this.errors_array = [];
            this.form.cd = data.cd;
            this.form.descr = data.descr;
            this.form.dt_simulador = this.formatDate(data.dt_simulador);
            this.form.percentual_advalorem = this.formatNumber(data.percentual_advalorem);
            this.form.obs_simulador = data.obs_simulador;

            if(data.municipio_inicio!==null)
            {
                this.form.municipio_ini = { label: data.municipio_inicio.nome, value: data.municipio_inicio.municipio_id, cd_ibge: data.municipio_inicio.cd_ibge };
            }
            else
            {
                this.form.municipio_ini = {label: "Selecione"};
            }

            if(data.municipio_fim!==null)
            {
                this.form.municipio_fim = { label: data.municipio_fim.nome, value: data.municipio_fim.municipio_id, cd_ibge: data.municipio_fim.cd_ibge };
            }
            else
            {
                this.form.municipio_fim = {label: "Selecione"};
            }

            this.trecho = null;
            this.trecho = [];
            data.simulador_trecho.forEach((obj)=>{
                this.trecho.push({ fornecedor:{ label: obj.fornecedor.cd+" - "+obj.fornecedor.pessoa_juridica.razao_social+" - "+this.onFormataCnpj(obj.fornecedor.pessoa_juridica.cnpj_base,obj.fornecedor.pessoa_juridica.cnpj_filial,obj.fornecedor.pessoa_juridica.cnpj_digito)+" - "+obj.fornecedor.pessoa_juridica.inscricao_estadual, value: obj.fornecedor.pessoa_juridica.pessoa_id }
                                 , trecho_custo: []
                                 , pedpartre_id: obj.pedpartre_id
                                 , tp_trecho: {label: obj.tp_trecho.descr, value: obj.tp_trecho.valor}
                                 , tp_trecho_custo: {label: obj.tp_trecho_custo.descr, value: obj.tp_trecho_custo.valor}
                                 , modal: {label: obj.b_modal.descr, value: obj.b_modal.bmodal_id}
                                 , municipio_ini: {label: obj.municipio_inicio.nome, value: obj.municipio_inicio.municipio_id, cd_ibge: obj.municipio_inicio.cd_ibge}
                                 , municipio_fim: {label: obj.municipio_fim.nome, value: obj.municipio_fim.municipio_id, cd_ibge: obj.municipio_fim.cd_ibge}
                                 , ordem:obj.ordem
                                 , principal:obj.principal.valor
                                 , advalorem: obj.perc_advalorem
                                 , subtrecho: obj.subtrecho
                                 , subtrechos_tmp: obj.subtrechos
                                 , subtrechos: []
                                 })
            });

            this.trecho.forEach((obj)=>{
                if(obj.subtrechos_tmp.length>0)
                {
                    var vlr_total_subtrecho = 0;
                    obj.subtrechos_tmp.forEach((obj2)=>{
                        obj2.simulador_trecho_custo.forEach((obj3)=>{
                            obj.subtrechos.push({
                                ordem: obj2.ordem,
                                principal: obj2.principal,
                                tp_trecho:  {label: obj2.tp_trecho.descr, value: obj2.tp_trecho.valor},
                                tp_trecho_custo: {label: obj2.tp_trecho_custo.descr, value: obj2.tp_trecho_custo.valor},
                                advalorem: obj2.perc_advalorem,
                                modal: {label: obj2.b_modal.descr, value: obj2.b_modal.bmodal_id},
                                municipio_ini: {label: obj2.municipio_inicio.nome, value: obj2.municipio_inicio.municipio_id, cd_ibge: obj.municipio_inicio.cd_ibge},
                                municipio_fim: {label: obj2.municipio_fim.nome, value: obj2.municipio_fim.municipio_id, cd_ibge: obj.municipio_fim.cd_ibge},
                                fornecedor: [],
                                subtrecho: obj2.subtrecho,
                                pedpartrc_id: obj3.pedpartrc_id,
                                custo: {label: obj3.custo.descr, value: obj3.custo.custo_id},
                                valor:obj3.vlr_custo,
                                descr_custo:obj3.descr
                            });
                             vlr_total_subtrecho = parseFloat(vlr_total_subtrecho)+parseFloat(obj3.vlr_custo);
                        });
                    });
                    obj.vlr_total_subtrecho = vlr_total_subtrecho;
                }
            });

            this.trecho_custo = null;
            this.trecho_custo = [];
            data.simulador_trecho.forEach((obj)=>{
                if(obj.simulador_trecho_custo.length>=1)
                {
                    obj.simulador_trecho_custo.forEach((obj2)=>
                    {
                        this.trecho.forEach((obj3)=>{
                            if(obj3.pedpartre_id==obj2.pedpartre_id)
                            {
                                // Trecho
                                obj3.trecho_custo.push({pedpartrc_id: obj2.pedpartrc_id, custo: {label: obj2.custo.descr, value: obj2.custo.custo_id}, tp_custo_trecho: {label: obj2.tp_custo.descr, value: obj2.tp_custo.valor}, valor:this.formatNumber(obj2.vlr_custo), descr:obj2.descr })
                            }
                        })
                    })
                }
            });

            data.simulador_trecho_receita.forEach((obj)=>{
                obj.simulador_trecho_custo.forEach((obj2)=>{
                    this.form.custo_receita = { label: obj2.descr, value: obj2.custo_id };
                });
            });
            this.form.simulador_id = data.simulador_id;
            this.form.trecho = this.trecho;
            //this.getReceita();
            //this.getDespesaCusto();
            this.$refs.modal_form.show();
        },
        onStore()
        {
            this.loading = true;
            this.isDisabled = true;
            this.form.trecho = this.trecho;
            this.form.post('/api/simulador/store').then(response =>
            {
                new ReturnApi(response, this)
            })
            .catch(errors =>
            {

                new ReturnApi(errors, this)
                this.errors_array = '';
                this.errors_array = [];
                for(var property in errors)
                {
                  if(errors.hasOwnProperty(property))
                  {
                     if(typeof(errors[property]) === 'object')
                     {
                     errors[property].forEach((obj)=>{
                        this.errors_array.push({erro: obj});
                     });
                     }
                  }
                }
            });
        },
        onUpdate(id)
        {
            this.loading = true;
            this.isDisabled = true;
            this.form.trecho = this.trecho;
            this.form.post('/api/simulador/update/'+id).then(response =>
            {
                new ReturnApi(response, this)
            })
            .catch(errors =>
            {
              new ReturnApi(errors, this)
              this.errors_array = '';
              this.errors_array = [];
              for(var property in errors)
              {
                if(errors.hasOwnProperty(property))
                {
                   if(typeof(errors[property]) === 'object')
                   {
                   errors[property].forEach((obj)=>{
                      this.errors_array.push({erro: obj});
                   });
                   }
                }
              }
          });
        },
        handleOkUc(e)
        {
            e.preventDefault();
            if(this.modal_acao=="i")
            {
               this.onStoreUc();
            }
        },
        getDespesaCusto()
        {
            this.vlr_bruto_despesa_total = 0;
            this.vlr_impostos_despesa_total = 0;
            this.vlr_liquido_despesa_total = 0;
            this.vlr_icms_despesa_total = 0;
            this.vlr_iss_despesa_total = 0;
            this.vlr_pis_cofins_despesa_total = 0;
            this.vlr_transporte_despesa_total = 0;
            this.vlr_servico_despesa_total = 0;
            this.trecho.forEach((obj)=>
            {
                obj.trecho_custo.forEach((obj2)=>
                {
                    this.vlr_liquido = obj2.valor.replace( ".", "" );
                    this.vlr_liquido = this.vlr_liquido.replace( ",", "." );
                    this.vlr_liquido = parseFloat( this.vlr_liquido.replace(/[^0-9.]/g, "") );
                    this.vlr_liquido_despesa_total  = this.vlr_liquido_despesa_total+this.vlr_liquido;

                    if(obj.tp_trecho_custo.value==1)
                    {
                        this.vlr_icms = obj2.vlr_icms.replace( ".", "" );
                        this.vlr_icms = this.vlr_icms.replace( ",", "." );
                        this.vlr_icms = parseFloat( this.vlr_icms.replace(/[^0-9.]/g, "") );
                        this.vlr_icms_despesa_total  = this.vlr_icms_despesa_total+this.vlr_icms;

                        this.vlr_pis_cofins = obj2.vlr_pis_cofins.replace( ".", "" );
                        this.vlr_pis_cofins = this.vlr_pis_cofins.replace( ",", "." );
                        this.vlr_pis_cofins = parseFloat( this.vlr_pis_cofins.replace(/[^0-9.]/g, "") );
                        this.vlr_pis_cofins_despesa_total  = this.vlr_pis_cofins_despesa_total+this.vlr_pis_cofins;

                        this.vlr_bruto = obj2.vlr_bruto.replace( ".", "" );
                        this.vlr_bruto = this.vlr_bruto.replace( ",", "." );
                        this.vlr_bruto = parseFloat( this.vlr_bruto.replace(/[^0-9.]/g, "") );
                        this.vlr_bruto_despesa_total = this.vlr_bruto_despesa_total+this.vlr_bruto;

                        this.vlr_impostos_despesa_total = this.vlr_impostos_despesa_total+this.vlr_pis_cofins+this.vlr_icms;
                        this.vlr_transporte_despesa_total = this.vlr_transporte_despesa_total+this.vlr_bruto;

                    }
                    else if(obj.tp_trecho_custo.value==2)
                    {
                        this.vlr_iss = obj2.vlr_iss.replace( ".", "" );
                        this.vlr_iss = this.vlr_iss.replace( ",", "." );
                        this.vlr_iss = parseFloat( this.vlr_iss.replace(/[^0-9.]/g, "") );
                        this.vlr_iss_despesa_total  = this.vlr_iss_despesa_total+this.vlr_iss;

                        this.vlr_pis_cofins = obj2.vlr_pis_cofins.replace( ".", "" );
                        this.vlr_pis_cofins = this.vlr_pis_cofins.replace( ",", "." );
                        this.vlr_pis_cofins = parseFloat( this.vlr_pis_cofins.replace(/[^0-9.]/g, "") );
                        this.vlr_pis_cofins_despesa_total  = this.vlr_pis_cofins_despesa_total+this.vlr_pis_cofins;

                        this.vlr_bruto = obj2.vlr_bruto.replace( ".", "" );
                        this.vlr_bruto = this.vlr_bruto.replace( ",", "." );
                        this.vlr_bruto = parseFloat( this.vlr_bruto.replace(/[^0-9.]/g, "") );
                        this.vlr_bruto_despesa_total = this.vlr_bruto_despesa_total+this.vlr_bruto;

                        this.vlr_impostos_despesa_total = this.vlr_impostos_despesa_total+this.vlr_pis_cofins+this.vlr_iss;
                        this.vlr_servico_despesa_total = this.vlr_servico_despesa_total+this.vlr_bruto;

                    }
                })

            })
            // Formatando
            this.vlr_bruto_despesa_total            = Number(this.vlr_bruto_despesa_total).toFixed(2).toString().replace(".", ",");
            this.vlr_impostos_despesa_total         = Number(this.vlr_impostos_despesa_total).toFixed(2).toString().replace(".", ",");
            this.vlr_liquido_despesa_total          = Number(this.vlr_liquido_despesa_total).toFixed(2).toString().replace(".", ",");
            this.vlr_icms_despesa_total             = Number(this.vlr_icms_despesa_total).toFixed(2).toString().replace(".", ",");
            this.vlr_iss_despesa_total              = Number(this.vlr_iss_despesa_total).toFixed(2).toString().replace(".", ",");
            this.vlr_pis_cofins_despesa_total       = Number(this.vlr_pis_cofins_despesa_total).toFixed(2).toString().replace(".", ",");
            this.vlr_transporte_despesa_total       = Number(this.vlr_transporte_despesa_total).toFixed(2).toString().replace(".", ",");
            this.vlr_servico_despesa_total          = Number(this.vlr_servico_despesa_total).toFixed(2).toString().replace(".", ",");
        },
        getDespesaCustoLinha: function(custo, trecho, param) {
            // Vai buscar a aliquota
            if(trecho.tp_trecho_custo.value==1)
            {
                this.Icms.forEach((obj)=>{
                    if(obj.uf_fim==param.municipio_fim.uf && obj.uf_ini==param.municipio_ini.uf)
                    {
                        this.vn_vlr_aliquota_icms = Number(this.formatNumberInterno(obj.aliquota_contribuinte)).toFixed(2);
                    }
                });

                this.vlr_liquido = custo.valor.replace( ".", "" );
                this.vlr_liquido = this.vlr_liquido.replace( ",", "." );
                this.vlr_liquido = parseFloat( this.vlr_liquido.replace(/[^0-9.]/g, "") );
                custo.vlr_icms       = (this.vlr_liquido/((100-this.vn_vlr_aliquota_icms)/100))-this.vlr_liquido;
                custo.vlr_pis_cofins = (this.vlr_liquido/(9.25/10))-this.vlr_liquido;
                custo.vlr_bruto            = this.vlr_liquido+custo.vlr_icms+custo.vlr_pis_cofins;
            }
            else if (trecho.tp_trecho_custo.value==2)
            {
                this.Iss.forEach((obj)=>{
                    if(obj.cd_ibge==param.municipio_ini.cd_ibge)
                    {
                        this.vn_vlr_aliquota_iss = Number(this.formatNumberInterno(obj.aliquota_iss)).toFixed(2);
                    }
                });

                this.vlr_liquido = custo.valor.replace( ".", "" );
                this.vlr_liquido = this.vlr_liquido.replace( ",", "." );
                this.vlr_liquido = parseFloat( this.vlr_liquido.replace(/[^0-9.]/g, "") );
                custo.vlr_iss       = (this.vlr_liquido/((100-this.vn_vlr_aliquota_iss)/100))-this.vlr_liquido;
                custo.vlr_pis_cofins = (this.vlr_liquido/(9.25/10))-this.vlr_liquido;
                custo.vlr_bruto            = this.vlr_liquido+custo.vlr_iss+custo.vlr_pis_cofins;
            }

            custo.aliquota_icms        = Number(this.vn_vlr_aliquota_icms).toFixed(2).toString().replace(".", ",");
            custo.aliquota_iss         = Number(this.vn_vlr_aliquota_iss).toFixed(2).toString().replace(".", ",");
            custo.vlr_bruto            = Number(custo.vlr_bruto).toFixed(2).toString().replace(".", ",");
            custo.vlr_icms             = Number(custo.vlr_icms).toFixed(2).toString().replace(".", ",");
            custo.vlr_iss              = Number(custo.vlr_iss).toFixed(2).toString().replace(".", ",");
            custo.vlr_pis_cofins       = Number(custo.vlr_pis_cofins).toFixed(2).toString().replace(".", ",");

            this.getDespesaCusto();
        },
        getReceitaCustoLinha: function(custo, param) {
            this.Icms.forEach((obj)=>{
                if(obj.uf_fim==param.municipio_fim.uf && obj.uf_ini==param.municipio_ini.uf)
                {
                    this.vn_vlr_aliquota_icms = Number(this.formatNumberInterno(obj.aliquota_contribuinte)).toFixed(2);
                }
            });

            this.vlr_liquido = custo.valor.replace( ".", "" );
            this.vlr_liquido = this.vlr_liquido.replace( ",", "." );
            this.vlr_liquido = parseFloat( this.vlr_liquido.replace(/[^0-9.]/g, "") );


            if(this.vn_vlr_aliquota_icms!="")
            {
                custo.vlr_icms       = (this.vlr_liquido/((100-this.vn_vlr_aliquota_icms)/100))-this.vlr_liquido;
            }
            else
            {
                this.vn_vlr_aliquota_icms = 0;
                custo.vlr_icms = 0;
            }

            custo.vlr_pis_cofins = (this.vlr_liquido/(9.25/10))-this.vlr_liquido;
            custo.vlr_bruto      = this.vlr_liquido+custo.vlr_icms+custo.vlr_pis_cofins;

            custo.aliquota_icms        = Number(this.vn_vlr_aliquota_icms).toFixed(2).toString().replace(".", ",");
            custo.vlr_bruto            = Number(custo.vlr_bruto).toFixed(2).toString().replace(".", ",");
            custo.vlr_icms             = Number(custo.vlr_icms).toFixed(2).toString().replace(".", ",");
            custo.vlr_pis_cofins       = Number(custo.vlr_pis_cofins).toFixed(2).toString().replace(".", ",");

            this.getReceitaCusto();
        },
        getReceitaCusto()
        {
            this.vlr_bruto_receita_total = 0;
            this.vlr_impostos_receita_total = 0;
            this.vlr_liquido_receita_total = 0;
            this.vlr_icms_receita_total = 0;
            this.vlr_iss_receita_total = 0;
            this.vlr_pis_cofins_receita_total = 0;
            this.vlr_transporte_receita_total = 0;
            this.vlr_servico_receita_total = 0;

            this.receita.forEach((obj2)=>
            {
                this.vlr_liquido = obj2.valor.replace( ".", "" );
                this.vlr_liquido = this.vlr_liquido.replace( ",", "." );
                this.vlr_liquido = parseFloat( this.vlr_liquido.replace(/[^0-9.]/g, "") );
                this.vlr_liquido_receita_total  = this.vlr_liquido_receita_total+this.vlr_liquido;

                this.vlr_icms = obj2.vlr_icms.replace( ".", "" );
                this.vlr_icms = this.vlr_icms.replace( ",", "." );
                this.vlr_icms = parseFloat( this.vlr_icms.replace(/[^0-9.]/g, "") );
                this.vlr_icms_receita_total  = this.vlr_icms_receita_total+this.vlr_icms;

                this.vlr_pis_cofins = obj2.vlr_pis_cofins.replace( ".", "" );
                this.vlr_pis_cofins = this.vlr_pis_cofins.replace( ",", "." );
                this.vlr_pis_cofins = parseFloat( this.vlr_pis_cofins.replace(/[^0-9.]/g, "") );
                this.vlr_pis_cofins_receita_total  = this.vlr_pis_cofins_receita_total+this.vlr_pis_cofins;

                this.vlr_bruto = obj2.vlr_bruto.replace( ".", "" );
                this.vlr_bruto = this.vlr_bruto.replace( ",", "." );
                this.vlr_bruto = parseFloat( this.vlr_bruto.replace(/[^0-9.]/g, "") );
                this.vlr_bruto_receita_total = this.vlr_bruto_receita_total+this.vlr_bruto;

                this.vlr_impostos_receita_total = this.vlr_impostos_receita_total+this.vlr_pis_cofins+this.vlr_icms;
                this.vlr_transporte_receita_total = this.vlr_transporte_receita_total+this.vlr_bruto;

            })
            // Formatando
            this.vlr_bruto_receita_total            = Number(this.vlr_bruto_receita_total).toFixed(2).toString().replace(".", ",");
            this.vlr_impostos_receita_total         = Number(this.vlr_impostos_receita_total).toFixed(2).toString().replace(".", ",");
            this.vlr_liquido_receita_total          = Number(this.vlr_liquido_receita_total).toFixed(2).toString().replace(".", ",");
            this.vlr_icms_receita_total             = Number(this.vlr_icms_receita_total).toFixed(2).toString().replace(".", ",");
            this.vlr_iss_receita_total              = Number(this.vlr_iss_receita_total).toFixed(2).toString().replace(".", ",");
            this.vlr_pis_cofins_receita_total       = Number(this.vlr_pis_cofins_receita_total).toFixed(2).toString().replace(".", ",");
            this.vlr_transporte_receita_total       = Number(this.vlr_transporte_receita_total).toFixed(2).toString().replace(".", ",");
            this.vlr_servico_receita_total          = Number(this.vlr_servico_receita_total).toFixed(2).toString().replace(".", ",");
        },
        formatNumberInterno (value) {
            return accounting.formatNumber(value, 2, ',', '.')
        },
        formatNumber (value) {
            return accounting.formatNumber(value, 2, '.', ',')
        },
        formatDate (value, fmt = 'DD MM YYYY') {
          return (value == null)
            ? ''
            : moment(value, 'YYYY/MM/DD').format(fmt)
        },
        getLivGeral() {
            this.helpForm.get('/api/simulador/jsonlistGeral').then(response =>
            {
                new ReturnApi(response, this, true, false, false);
                response.municipio.forEach((obj)=>
                {
                    this.optionsMunicipioIni.push({ label: obj.nome+" - "+obj.cd_ibge, value: obj.municipio_id, uf: obj.uf.cd, cd_ibge: obj.cd_ibge })
                    this.optionsMunicipioFim.push({ label: obj.nome+" - "+obj.cd_ibge, value: obj.municipio_id, uf: obj.uf.cd, cd_ibge: obj.cd_ibge })
                })
                response.status.forEach((obj)=>
                {
                    this.optionsLivStatus.push({ label: obj.descr, value: obj.valor })
                })
                response.status_trecho.forEach((obj)=>
                {
                    this.optionsLivStatusTrecho.push({ label: obj.descr, value: obj.valor })
                })
                response.b_modal.forEach((obj)=>
                {
                    this.optionsBModal.push({ label: obj.descr, value: obj.bmodal_id, cd: obj.cd })
                })
                response.tp_trecho.forEach((obj)=>
                {
                    this.optionsLivTpTrecho.push({ label: obj.descr, value: obj.valor })
                })
                response.tp_custo.forEach((obj)=>
                {
                    this.optionsLivTpCusto.push({ label: obj.descr, value: obj.valor })
                })
                response.status_trecho_custo.forEach((obj)=>
                {
                    this.optionsLivStatusTrechoCusto.push({ label: obj.descr, value: obj.valor })
                })
                response.tp_custo_trecho.forEach((obj)=>
                {
                    this.optionsLivTpCustoTrecho.push({ label: obj.descr, value: obj.valor })
                })
                response.custo.forEach((obj)=>
                {
                    this.optionsCusto.push({ label: obj.descr, value: obj.custo_id })
                    if(obj.is_cfrete==1)
                    {
                        this.optionsCustoCFrete.push({ label: obj.descr, value: obj.custo_id })
                    }
                })
                response.tp_trecho_custo.forEach((obj)=>
                {
                    this.optionsLivTpTrechoCusto.push({ label: obj.descr, value: obj.valor })
                })
                response.icms.forEach((obj)=>
                {
                    this.Icms.push({ aliquota_contribuinte: obj.aliquota_contribuinte, aliquota_nao_contribuinte: obj.aliquota_nao_contribuinte, uf_ini: obj.uf_ini.cd, uf_fim: obj.uf_fim.cd })
                })
                response.iss.forEach((obj)=>
                {
                    this.Iss.push({ aliquota_iss: obj.aliquota_iss, cd_ibge: obj.municipio.cd_ibge })
                })
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        listaClientesTomador(search) {
            if(search.length>=3)
            {
                this.isLoadingTom = true;
                this.helpForm.search = search;
                this.helpForm.status = 1;
                this.helpForm.post('/api/pessoa/jsonlist').then(response =>
                {
                    this.optionsTomador = [];
                    new ReturnApi(response, this, true, false, false);
                    response.items.forEach((obj)=>
                    {
                        this.optionsTomador.push({ label: obj.pessoa.cd+" - "+obj.razao_social+" - "+this.onFormataCnpj(obj.cnpj_base,obj.cnpj_filial,obj.cnpj_digito)+" - "+obj.inscricao_estadual, value: obj.pessoa_id })
                    });
                    this.isLoadingTom = false;
                })
                .catch(errors =>
                {
                    new ReturnApi(errors, this)
                  });
              }
          },
        listaClientesFornecedor(search)
        {
            if(search.length>=3)
            {
              this.isLoadingFor = true;
              this.helpForm.search = search;
              this.helpForm.post('/api/pessoa/jsonlist/fornecedor').then(response =>
              {
                  this.optionsFornecedor = [];
                  new ReturnApi(response, this, true, false, false);
                  response.items.forEach((obj)=>
                  {
                      this.optionsFornecedor.push({ label: obj.pessoa.cd+" - "+obj.razao_social+" - "+this.onFormataCnpj(obj.cnpj_base,obj.cnpj_filial,obj.cnpj_digito)+" - "+obj.inscricao_estadual, value: obj.pessoa_id })
                  });
                  this.isLoadingFor = false;
              })
              .catch(errors =>
              {
                  new ReturnApi(errors, this)
                });
            }
        },
        onActivateDesactivate(action, data, tipo)
        {
            // Tipo = true = Checkbox
            if(tipo)
            {
                this.helpForm.statusRecord = [];
                this.helpForm.statusRecord.push({ id: data.simulador_id, status: action });
            }
            else
            {
                this.helpForm.statusRecord = [];
                this.$refs.vuetable.selectedTo.forEach((obj)=>{
                    this.helpForm.statusRecord.push({ id: obj, status: action })
                });
            }

            this.helpForm.post('/api/simulador/status').then(response =>
            {
                new ReturnApi(response, this)
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });

        },
        calcLinha() {
            // Vai buscar a aliquota
            this.Icms.forEach((obj)=>{
                if(obj.uf_fim==pedido_unidade_carga.pedido.municipio_fim.uf.cd && obj.uf_ini==pedido_unidade_carga.pedido.municipio_inicio.uf.cd)
                {
                    this.aliquota = Number(this.formatNumberInterno(obj.aliquota_contribuinte)).toFixed(2).toString().replace(".", ",");
                }
            });
        },
        limitText (count) {
          return ' e ${count} outros clientes'
        },
                onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
          return formatCNPJFromParts(cnpj_base, cnpj_filial, cnpj_digito);
        },
        addRowTrecho: function(e, en_subtrecho) {
            e.preventDefault();
            this.trecho.push({
                ordem: "",
                principal: 2,
                tp_trecho: [],
                tp_trecho_custo: [],
                advalorem: '',
                modal: [],
                municipio_ini: [],
                municipio_fim: [],
                fornecedor: [],
                status: "",
                subtrecho: en_subtrecho,
                tp_custo: "",
                vlr_total_subtrecho: 0,
                trecho_custo: [],
                subtrechos: [],
            });
        },
        addRowSubTrecho: function(e, row) {
            e.preventDefault();
            row.subtrechos.push({
                ordem: "",
                principal: 2,
                tp_trecho: [],
                tp_trecho_custo: [],
                advalorem: '',
                modal: [],
                municipio_ini: [],
                municipio_fim: [],
                fornecedor: [],
                status: "",
                tp_custo: "",
                subtrecho: 1,
            });
        },
        removeRowTrecho: function(index) {
            this.trecho.splice(index, 1);
            this.getDespesaCusto()
        },
        removeRowSubTrecho: function(row, index) {
            row.subtrechos.splice(index, 1);
            if(row.subtrechos.length==0)
            {
                row.vlr_total_subtrecho = 0;
            }
            this.getDespesaCusto();
        },
        addRowTrechoCusto: function(e, row, index) {
            e.preventDefault();
            this.trecho[index].trecho_custo.push({
                valor: "",
                descr: "",
                tp_custo_trecho: [],
                custo: [],
            });
        },
        removeRowTrechoCusto: function(row,index) {
            row.trecho_custo.splice(index, 1);
            this.getDespesaCusto();
        },
        addRowReceita: function(e) {
            e.preventDefault();
            this.receita.push({
              valor: 0,
              aliquota_icms: 0,
              aliquota_iss: 0,
              vlr_icms: 0,
              vlr_iss: 0,
              vlr_pis_cofins: 0,
              vlr_bruto: 0,
              custo: [],
            });
        },
        removeRowReceita: function(index) {
            this.receita.splice(index, 1);
        },
        onError(response) {
            new ReturnApi(response.response, this, true, true, false);
        },
        getPermission(checkPermission) {
            return this.getPermissionFw(checkPermission);
        },
    },
    computed: {
        vuetableFilterRow: {
          get () {
            return this.$store.state.vuetable.filterRow;
          },
        },
        isLoaded: {
            get() {
                return this.$store.getters.isloaded;
            }
        }
    }
  }
  </script>